<template>
  <div :class="classObj" class="app-wrapper">
    <div class="logo-bar">
      <div class="logo-bg">
        <img src="@/assets/logo-icon.png" />
      </div>
      <div class="sys-name">
        <h1>全国职业经理人才数据库系统</h1>
      </div>
    </div>
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <navbar />
      <tags-view />
      <app-main class="app-main" />
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";

export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("CloseSideBar", { withoutAnimation: false });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.logo-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 65px;
  background-color: #fff;
  border-bottom: 1px solid #e4e7ed;
}
.logo-bg {
  width: 180px;
  height: 65px;
  background-color: #f6f6f6;
  display: inline-block;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  float: left;
  transition: width 0.3s;
}
.hideSidebar .logo-bg {
  width: 65px;
}
.logo-bg img {
  width: 45px;
}
.sys-name {
  display: inline-block;
  height: 45px;
  text-align: left;
  padding-left: 15px;
  padding-top: 15px;
  float: left;
}
.sys-name h1 {
  color: #304156;
  font-size: 28px;
  font-style: oblique;
  margin: 0;
}
</style>
